export const getYoutubeIframe = (youtubeId)=>{
    return `<iframe width="560" height="315" src="https://www.youtube.com/embed/${youtubeId}?rel=0&enablejsapi=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
}

export const colors = {
    violet: '#5A36E4',
  };